import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import router from ".././router/index";
import createPersistedState from "vuex-persistedstate";
import { nanoid } from "nanoid";

Vue.use(Vuex);

export const SET_NANOID = "SET_NANOID";
export const SET_CLAVEEMPRESA = "SET_CLAVEEMPRESA";
export const CLEAR_CLAVEEMPRESA = "CLEAR_CLAVEEMPRESA";
export const SET_USER = "SET_USER";
export const SET_USERNAME = "SET_USERNAME";
export const SET_EMAIL = "SET_EMAIL";
export const SET_CREDENCIALES = "SET_CREDENCIALES";
export const SET_TOKEN = "SET_TOKEN";
export const SET_ROOT_LOCATION = "SET_ROOT_LOCATION";
export const SET_ROOT_LOCATIONS = "SET_ROOT_LOCATIONS";
export const SET_PERFILES = "SET_PERFILES";
export const CLEAR_TOKEN = "CLEAR_TOKEN";
export const CLEAR_USER = "CLEAR_USER";
export const CLEAR_USERNAME = "CLEAR_USERNAME";
export const CLEAR_EMAIL = "CLEAR_EMAIL";
export const CLEAR_ROOT_LOCATION = "CLEAR_ROOT_LOCATION";
export const CLEAR_ROOT_LOCATIONS = "CLEAR_ROOT_LOCATIONS";
export const CLEAR_PERFILES = "CLEAR_PERFILES";
export const SET_ANALYTICS_FILTER = "SET_ANALYTICS_FILTER";
export const CLEAR_ANALYTICS_FILTER = "CLEAR_ANALYTICS_FILTER";
export const SET_PRE_FILTER = "SET_PRE_FILTER";
export const CLEAR_PRE_FILTER = "CLEAR_PRE_FILTER";
export const SET_GO_BACK = "SET_GO_BACK";
export const CLEAR_GO_BACK = "CLEAR_GO_BACK";

// Firebase
export const SET_FIREBASE = "SET_FIREBASE";

// Graph Filter
export const SET_DATE_GRAPH = "SET_DATE_GRAPH";
export const SET_CROP_GRAPH = "SET_CROP_GRAPH";
export const SET_LOCATION_GRAPH = "SET_LOCATION_GRAPH";
export const CLEAR_CROP_GRAPH = "CLEAR_CROP_GRAPH";
export const CLEAR_LOCATION_GRAPH = "CLEAR_LOCATION_GRAPH";

const SERVER = process.env.NODE_ENV !== 'development' ? (process.env.NODE_ENV === 'production' ? 'be.hooch.com.mx' : 'newton.klayware.com') : 'localhost:8000'

const INSTANCIA = "hooch";
const BASE_URL = `//${SERVER}/${INSTANCIA}`;

export default new Vuex.Store({
  state: {
    clave_empresa: "",
    user: "",
    userName: "",
    email: "",
    token: "",
    rootLocations: [],
    rootLocation: null,
    perfiles: [],
    // Graphs
    dateGraphs: [],
    cropGraphs: null,
    locationGraphs: null,
    count: [],
    enviado: false,
    analytics: {},
    pre_analytics: {},
    go_back: {}
  },
  getters: {
    allCredenciales: state => state.credenciales,
    analyticsFilter: state => state.analytics,
    preFilter: state => state.pre_analytics,
    goBack: state => state.go_back,
    gToken: state => state.token,
    rootLocationsIds: state => state.rootLocations.map(m => m.value),
    MediaGet: state =>
      `${BASE_URL}:${state.clave_empresa}/media:obtener?media=`,
    nanoid: state => state.nanoid
  },

  plugins: [createPersistedState()],
  mutations: {
    increment(state, n) {
      state.enviado = n;
      // state.count = [{value:1, label:""},ubi2]
    },
    [SET_NANOID](state, payload) {
      state.nanoid = payload;
    },
    [SET_CLAVEEMPRESA](state, payload) {
      state.clave_empresa = payload;
    },
    [CLEAR_CLAVEEMPRESA](state) {
      state.clave_empresa = "";
    },
    [SET_TOKEN](state, payload) {
      state.token = payload;
    },
    [CLEAR_TOKEN](state) {
      state.token = "";
    },
    [SET_USER](state, payload) {
      state.user = payload;
    },
    [CLEAR_USER](state) {
      state.user = "";
    },
    [SET_USERNAME](state, payload) {
      state.userName = payload;
    },
    [CLEAR_USERNAME](state) {
      state.userName = "";
    },
    [SET_EMAIL](state, payload) {
      state.email = payload;
    },
    [SET_CREDENCIALES](state, payload) {
      state.credenciales = payload;
    },
    [CLEAR_EMAIL](state) {
      state.email = "";
    },
    [SET_ROOT_LOCATION](state, payload) {
      state.rootLocation = payload;
    },
    [SET_DATE_GRAPH](state, payload) {
      state.dateGraphs = payload;
    },
    [SET_FIREBASE](state, payload) {
      state.firebase = payload;
    },
    [SET_CROP_GRAPH](state, payload) {
      state.cropGraphs = payload;
    },
    [CLEAR_CROP_GRAPH](state) {
      state.cropGraphs = null;
    },
    [SET_LOCATION_GRAPH](state, payload) {
      state.locationGraphs = payload;
    },
    [CLEAR_LOCATION_GRAPH](state) {
      state.locationGraphs = null;
    },
    [CLEAR_ROOT_LOCATION](state) {
      state.rootLocation = null;
    },
    [SET_ROOT_LOCATIONS](state, payload) {
      state.rootLocations = payload;
    },
    [CLEAR_ROOT_LOCATIONS](state) {
      state.rootLocations = [];
    },
    [SET_PERFILES](state, payload) {
      state.perfiles = payload;
    },
    [CLEAR_PERFILES](state) {
      state.perfiles = [];
    },
    [SET_ANALYTICS_FILTER](state, payload) {
      state.analytics = payload;
    },
    [CLEAR_ANALYTICS_FILTER](state) {
      state.analytics = {};
    },
    [SET_PRE_FILTER](state, payload) {
      state.pre_analytics = payload;
    },
    [CLEAR_PRE_FILTER](state) {
      state.pre_analytics = {};
    },
    [SET_GO_BACK](state, payload) {
      state.go_back = payload;
    },
    [CLEAR_GO_BACK](state) {
      state.go_back = {};
    }
  },
  actions: {
    async getNanoid({ commit }) {
      const nanoid_ = await nanoid(25);
      commit("SET_NANOID", nanoid_);
      return nanoid_;
    },
    login({ commit, dispatch }, call) {
      // try {
      //   const { data } = await axios.post(
      //     `${BASE_URL}:${call.claveEmpresa}/usuarios:obtener_apikey`,
      //     {
      //       correo: call.email,
      //       contrasena: call.password
      //     }
      //   );
      //   let api_key = data.data.apikey;
      //   commit("SET_CLAVEEMPRESA", call.claveEmpresa);

      //   dispatch("getToken", {
      //     email: call.email,
      //     apikey: api_key
      //   });
      // } catch (error) {
      //   console.log(error.response.data);

      //   return error.response.data;
      // }

      return new Promise((res, rej) => {
        axios
          .post(`${BASE_URL}:${call.claveEmpresa}/usuarios:obtener_apikey`, {
            correo: call.email,
            contrasena: call.password
          })
          .then(response => {
            let api_key = response.data.data.apikey;
            commit("SET_CLAVEEMPRESA", call.claveEmpresa);

            dispatch("getToken", {
              email: call.email,
              apikey: api_key
            })
              .then(() => {
                // console.log(resp);
              })
              .catch(reject => {
                return rej(reject);
              });
          })
          .catch(err => {
            // console.log(err);
            return rej(err.response);
          });
      });
    },
    recoverPassword({ state }, body) {
      // try {
      console.log(state);
      return new Promise((res, rej) => {
        axios
          .post(
            `${BASE_URL}:${body.clave_empresa}/usuarios:recuperar_contrasena`,
            {
              correo: body.correo
            }
          )
          .then(({ data }) => {
            res(data);
          })
          .catch(err => rej(err.response));
      });
    },
    getToken({ dispatch, commit, state }, call) {
      // try {

      return new Promise((res, rej) => {
        axios
          .post(`${BASE_URL}:${state.clave_empresa}/sesion:iniciar`, {
            correo: call.email,
            apikey: call.apikey
          })
          .then(({ data }) => {
            // console.log(data.data.jwt);
            commit("SET_TOKEN", data.data.jwt);
            // console.log(data.data.usuario.roles);
            commit("SET_USER", data.data.usuario.id);
            commit("SET_PERFILES", data.data.usuario.roles);
            commit("SET_USERNAME", data.data.usuario.nombre);
            commit("SET_EMAIL", data.data.usuario.correo);
            commit("SET_CREDENCIALES", data.data.usuario.credenciales);
            router.push({ name: "Home" });
            if (state.firebase) {
              dispatch("pushToken", {});
            }
          })
          .catch(err => rej(err.response));
      });
    },
    pushToken({ dispatch, state }) {
      console.log("state", state);
      const uniqueId =
        localStorage.getItem("uniqueId") || hash(navigator.userAgent);
      localStorage.setItem("uniqueId", uniqueId);

      const firebasSku = `${uniqueId}-${state.firebase}`;

      if (
        !!state.token &&
        state.firebase &&
        uniqueId &&
        localStorage.getItem("firebasSku") !== firebasSku
      ) {
        if (
          !state?.credenciales?.includes(
            "@catalogo:schema=firebase|method=actualizar"
          )
        ) {
          console.log("User not have firebase token");
          return;
        }
        localStorage.getItem("firebasSku", firebasSku);
        dispatch("customActualizarHTTP", {
          schema: "firebase",
          payload: {
            correo: state?.email,
            uniqueId: uniqueId,
            token: state.firebase
          }
        })
          .then(res => {
            console.log("res:K", res);
          })
          .catch(err => {
            console.log("err:K", err);
          });
      }
    },
    // async getToken({ commit, state }, call) {
    //   try {
    //     const { data } = await axios.post(
    //       `${BASE_URL}:${state.clave_empresa}/sesion:iniciar`,
    //       {
    //         correo: call.email,
    //         apikey: call.apikey
    //       }
    //     );
    //     commit("SET_TOKEN", data.data.jwt);
    //     commit("SET_USER", data.data.usuario.id);
    //     commit("SET_USERNAME", data.data.usuario.nombre);
    //     commit("SET_EMAIL", data.data.usuario.correo);
    //     router.push({ name: "Home" });
    //   } catch (error) {
    //     return error.response.data;
    //     // console.log(error.response.data);
    //   }

    // return new Promise((res, rej) => {
    //   axios
    //     .post(`${BASE_URL}:${state.clave_empresa}/sesion:iniciar`, {
    //       correo: call.email,
    //       apikey: call.apikey
    //     })
    //     .then(response => {
    //       // console.log(response);

    //       commit("SET_TOKEN", response.data.data.jwt);
    //       commit("SET_USER", response.data.data.usuario.id);
    //       commit("SET_USERNAME", response.data.data.usuario.nombre);
    //       commit("SET_EMAIL", response.data.data.usuario.correo);
    //       return response.data.status;
    //     })
    //     .catch(err => rej(err));
    // });
    // },
    clearToken({ commit, state, dispatch }) {
      return new Promise((res, rej) => {
        axios
          .post(
            `${BASE_URL}:${state.clave_empresa}/sesion:cerrar`,
            {},
            {
              headers: { authorization: `Bearer ${state.token}` }
            }
          )
          .then(() => {
            console.log("cerrat sesion correcto");
          })
          .catch(err => {
            customCatchError(err, dispatch, rej);
          })
          .finally(() => {
            commit("CLEAR_TOKEN");
            commit("CLEAR_CLAVEEMPRESA");
            commit("CLEAR_USER");
            commit("CLEAR_ROOT_LOCATION");
            commit("CLEAR_ROOT_LOCATIONS");
            commit("CLEAR_CROP_GRAPH");
            commit("CLEAR_LOCATION_GRAPH");
            commit("CLEAR_PERFILES");
            commit("CLEAR_USERNAME");
            commit("CLEAR_EMAIL");
            commit("CLEAR_ANALYTICS_FILTER");
            commit("CLEAR_PRE_FILTER");
            commit("CLEAR_GO_BACK");
            router.push({ name: "Login" });
          });
      });
    },
    setRootLocation({ commit }, location) {
      commit("SET_ROOT_LOCATION", location);
    },
    setRootLocations({ commit }, locations) {
      commit("SET_ROOT_LOCATIONS", locations);
    },
    setFirebase({ commit, dispatch, state }, dates) {
      commit("SET_FIREBASE", dates);
      if (state.token) {
        dispatch("pushToken", {});
      }
    },
    setDateGraph({ commit }, dates) {
      commit("SET_DATE_GRAPH", dates);
    },
    setCropGraph({ commit }, crop) {
      commit("SET_CROP_GRAPH", crop);
    },
    setLocationGraph({ commit }, location) {
      commit("SET_LOCATION_GRAPH", location);
    },
    logout({ commit }) {
      commit("CLEAR_TOKEN");
      commit("CLEAR_CLAVEEMPRESA");
      commit("CLEAR");
      commit("CLEAR_USER");
      commit("CLEAR_ROOT_LOCATION");
      commit("CLEAR_ROOT_LOCATIONS");
      commit("CLEAR_CROP_GRAPH");
      commit("CLEAR_LOCATION_GRAPH");
      commit("CLEAR_USERNAME");
      commit("CLEAR_EMAIL");
      commit("CLEAR_ANALYTICS_FILTER");
      commit("CLEAR_PRE_FILTER");
      commit("CLEAR_GO_BACK");
      router.push({ name: "Login" });
    },
    customHTTP({ state, commit, dispatch }, body) {
      // try {
      return new Promise((res, rej) => {
        axios
          .post(
            `${BASE_URL}:${state.clave_empresa}/catalogos:consultar`,
            body,
            { headers: { authorization: `Bearer ${state.token}` } }
          )
          .then(response => {
            let newToken = response.headers.authorization;
            newToken = newToken.replace("Bearer ", "");
            commit("SET_TOKEN", newToken);
            return res(response.data);
          })
          .catch(err => {
            customCatchError(err, dispatch, rej);
          });
      });
    },
    httpAny({ state, commit, dispatch }, request) {
      // try {
      // console.log(request);
      return new Promise((res, rej) => {
        axios
          .post(
            `${BASE_URL}:${state.clave_empresa}/${request.endpoint}`,
            request.body,
            { headers: { authorization: `Bearer ${state.token}` } }
          )
          .then(response => {
            let newToken = response.headers.authorization;
            newToken = newToken.replace("Bearer ", "");
            commit("SET_TOKEN", newToken);
            return res(response.data);
          })
          .catch(err => {
            customCatchError(err, dispatch, rej);
          });
      });
    },
    customActualizarHTTP({ state, commit, dispatch }, body) {
      // try {

      return new Promise((res, rej) => {
        axios
          .post(
            `${BASE_URL}:${state.clave_empresa}/catalogos:actualizar`,
            body,
            { headers: { authorization: `Bearer ${state.token}` } }
          )
          .then(response => {
            let newToken = response.headers.authorization;
            newToken = newToken.replace("Bearer ", "");
            commit("SET_TOKEN", newToken);
            return res(response.data);
          })
          .catch(err => {
            customCatchError(err, dispatch, rej);
          });
      });
    },
    customRemplazarHTTP({ state, commit, dispatch }, body) {
      // try {

      return new Promise((res, rej) => {
        axios
          .post(
            `${BASE_URL}:${state.clave_empresa}/catalogos:remplazar`,
            body,
            { headers: { authorization: `Bearer ${state.token}` } }
          )
          .then(response => {
            let newToken = response.headers.authorization;
            newToken = newToken.replace("Bearer ", "");
            commit("SET_TOKEN", newToken);
            return res(response.data);
          })
          .catch(err => {
            customCatchError(err, dispatch, rej);
          });
      });
    },
    customEliminarHTTP({ state, commit, dispatch }, body) {
      // try {

      return new Promise((res, rej) => {
        axios
          .post(`${BASE_URL}:${state.clave_empresa}/catalogos:eliminar`, body, {
            headers: { authorization: `Bearer ${state.token}` }
          })
          .then(response => {
            let newToken = response.headers.authorization;
            newToken = newToken.replace("Bearer ", "");
            commit("SET_TOKEN", newToken);
            return res(response.data);
          })
          .catch(err => {
            customCatchError(err, dispatch, rej);
          });
      });
    },
    customImageHTTP({ state, dispatch }, body) {
      // try {

      return new Promise((res, rej) => {
        axios
          .post(`${BASE_URL}:${state.clave_empresa}/media:cargar`, body, {
            headers: {
              "Content-Type": "multipart/form-data",
              authorization: `Bearer ${state.token}`
            }
          })
          .then(({ data }) => res(data))
          .catch(err => {
            customCatchError(err, dispatch, rej);
          });
      });
    },
    customImageObtenerHTTP({ state }, body) {
      // try {

      return fetch(`${BASE_URL}:${state.clave_empresa}/media:obtener`, {
        method: "POST", // or 'PUT'
        body: JSON.stringify(body), //
        headers: {
          "Content-Type": "application/json",
          authorization: `Bearer ${state.token}`
        }
      })
        .then(res => {
          return res.blob();
        })
        .catch(err => {
          console.log(err);
          return err;
        });
      // .then(blob => {
      //   console.log(blob);
      // });
      // .then(response => response);

      // return new Promise((res, rej) => {
      //   axios
      //     .post(`${BASE_URL}:${state.clave_empresa}/media:obtener`, body, {
      //       headers: {
      //         authorization: `Bearer ${state.token}`
      //       }
      //     })
      //     .then(({ data }) => res(data))
      //     .catch(err => {
      //       rej(err.response.data);
      //       console.log(err);
      //     });
      // });
    },
    customBalanceHTTP({ state, commit, dispatch }, body) {
      // try {

      return new Promise((res, rej) => {
        axios
          .post(`${BASE_URL}:${state.clave_empresa}/balances:consultar`, body, {
            headers: {
              authorization: `Bearer ${state.token}`
            }
          })
          .then(response => {
            let newToken = response.headers.authorization;
            newToken = newToken.replace("Bearer ", "");
            commit("SET_TOKEN", newToken);
            // console.log(response);
            return res(response.data);
          })
          .catch(err => {
            customCatchError(err, dispatch, rej);
          });
      });
    },
    customDocumentoHTTP({ state, commit, dispatch }, body) {
      // try {

      return new Promise((res, rej) => {
        axios
          .post(
            `${BASE_URL}:${state.clave_empresa}/documentos:consultar`,
            body,
            {
              headers: {
                authorization: `Bearer ${state.token}`
              }
            }
          )
          .then(response => {
            let newToken = response.headers.authorization;
            newToken = newToken.replace("Bearer ", "");
            commit("SET_TOKEN", newToken);

            return res(response.data);
          })
          .catch(err => {
            customCatchError(err, dispatch, rej);
          });
      });
    },
    async customDocumentoAddHTTP({ state, commit, dispatch }, body) {
      // try {
      if (Array.isArray(body)) {
        for (let itm of body) {
          if (!itm.payload.encabezado.nanoid) {
            itm.payload.encabezado.nanoid = state.nanoid;
            await dispatch("getNanoid");
          }
        }
      } else if (!body.payload.encabezado.nanoid) {
        body.payload.encabezado.nanoid = state.nanoid;
      }
      return new Promise((res, rej) => {
        axios
          .post(`${BASE_URL}:${state.clave_empresa}/documentos:crear`, body, {
            headers: { authorization: `Bearer ${state.token}` }
          })
          .then(response => {
            let newToken = response.headers.authorization;
            newToken = newToken.replace("Bearer ", "");
            commit("SET_TOKEN", newToken);
            dispatch("getNanoid");
            return res(response.data);
          })
          .catch(err => {
            if (
              err?.response?.data?.code?.includes(
                ".crear_before.nanoid_registrado"
              )
            ) {
              dispatch("getNanoid");
              return res({});
            }
            customCatchError(err, dispatch, rej);
          });
      });
    },
    customDocumentoCancelHTTP({ state, commit, dispatch }, body) {
      // try {

      return new Promise((res, rej) => {
        axios
          .post(
            `${BASE_URL}:${state.clave_empresa}/documentos:cancelar`,
            body,
            {
              headers: { authorization: `Bearer ${state.token}` }
            }
          )
          .then(response => {
            let newToken = response.headers.authorization;
            newToken = newToken.replace("Bearer ", "");
            commit("SET_TOKEN", newToken);
            return res(response.data);
          })
          .catch(err => {
            customCatchError(err, dispatch, rej);
          });
      });
    },
    customDocumentoRemplazarHTTP({ state, commit, dispatch }, body) {
      // try {

      return new Promise((res, rej) => {
        axios
          .post(
            `${BASE_URL}:${state.clave_empresa}/documentos:remplazar`,
            body,
            {
              headers: { authorization: `Bearer ${state.token}` }
            }
          )
          .then(response => {
            let newToken = response.headers.authorization;
            newToken = newToken.replace("Bearer ", "");
            commit("SET_TOKEN", newToken);
            return res(response.data);
          })
          .catch(err => {
            customCatchError(err, dispatch, rej);
          });
      });
    },
    customDocumentoActualizarHTTP({ state, commit, dispatch }, body) {
      // try {

      return new Promise((res, rej) => {
        axios
          .post(
            `${BASE_URL}:${state.clave_empresa}/documentos:actualizar`,
            body,
            {
              headers: { authorization: `Bearer ${state.token}` }
            }
          )
          .then(response => {
            let newToken = response.headers.authorization;
            newToken = newToken.replace("Bearer ", "");
            commit("SET_TOKEN", newToken);
            return res(response.data);
          })
          .catch(err => {
            customCatchError(err, dispatch, rej);
          });
      });
    },
    customRolActHTTP({ state, commit, dispatch }, body) {
      // try {

      return new Promise((res, rej) => {
        axios
          .post(`${BASE_URL}:${state.clave_empresa}/roles:actualizar`, body, {
            headers: { authorization: `Bearer ${state.token}` }
          })
          .then(response => {
            let newToken = response.headers.authorization;
            newToken = newToken.replace("Bearer ", "");
            commit("SET_TOKEN", newToken);
            return res(response.data);
          })
          .catch(err => {
            customCatchError(err, dispatch, rej);
          });
      });
    },
    customRolHTTP({ state, commit, dispatch }, body) {
      // try {

      return new Promise((res, rej) => {
        axios
          .post(`${BASE_URL}:${state.clave_empresa}/roles:consultar`, body, {
            headers: { authorization: `Bearer ${state.token}` }
          })
          .then(response => {
            let newToken = response.headers.authorization;
            newToken = newToken.replace("Bearer ", "");
            commit("SET_TOKEN", newToken);
            return res(response.data);
          })
          .catch(err => {
            customCatchError(err, dispatch, rej);
          });
      });
    },
    customRolDeleteHTTP({ state, commit, dispatch }, body) {
      // try {

      return new Promise((res, rej) => {
        axios
          .post(`${BASE_URL}:${state.clave_empresa}/roles:eliminar`, body, {
            headers: { authorization: `Bearer ${state.token}` }
          })
          .then(response => {
            let newToken = response.headers.authorization;
            newToken = newToken.replace("Bearer ", "");
            commit("SET_TOKEN", newToken);
            return res(response.data);
          })
          .catch(err => {
            customCatchError(err, dispatch, rej);
          });
      });
    },
    async getUsuarioHTTP({state, commit, dispatch}){
      const id = state.user;
      const user = await dispatch('customUsuarioHTTP',{
        "filter": {
            "where": [
                {
                    "field": "id",
                    "operator": "=",
                    "value": id
                }
            ]
        }
      })

      commit("SET_USER", user.data[0].id);
      commit("SET_PERFILES", user.data[0].roles);
      commit("SET_USERNAME", user.data[0].nombre);
      commit("SET_EMAIL", user.data[0].correo);
      commit("SET_CREDENCIALES", user.data[0].credenciales);
    },
    customUsuarioHTTP({ state, commit, dispatch }, body) {
      // try {

      return new Promise((res, rej) => {
        axios
          .post(`${BASE_URL}:${state.clave_empresa}/usuarios:consultar`, body, {
            headers: { authorization: `Bearer ${state.token}` }
          })
          .then(response => {
            let newToken = response.headers.authorization;
            newToken = newToken.replace("Bearer ", "");
            commit("SET_TOKEN", newToken);
            return res(response.data);
          })
          .catch(err => {
            customCatchError(err, dispatch, rej);
          });
      });
    },
    customUsuarioActualizarHTTP({ state, commit, dispatch }, body) {
      // try {

      return new Promise((res, rej) => {
        axios
          .post(
            `${BASE_URL}:${state.clave_empresa}/usuarios:actualizar`,
            body,
            {
              headers: { authorization: `Bearer ${state.token}` }
            }
          )
          .then(response => {
            let newToken = response.headers.authorization;
            newToken = newToken.replace("Bearer ", "");
            commit("SET_TOKEN", newToken);
            return res(response.data);
          })
          .catch(err => {
            customCatchError(err, dispatch, rej);
          });
      });
    },
    customUsuarioModificarPasswordHTTP({ state, commit, dispatch }, body) {
      // try {

      return new Promise((res, rej) => {
        axios
          .post(
            `${BASE_URL}:${state.clave_empresa}/usuarios:modificar_contrasena`,
            body,
            {
              headers: { authorization: `Bearer ${state.token}` }
            }
          )
          .then(response => {
            let newToken = response.headers.authorization;
            newToken = newToken.replace("Bearer ", "");
            commit("SET_TOKEN", newToken);
            return res(response.data);
          })
          .catch(err => {
            customCatchError(err, dispatch, rej);
          });
      });
    },
    customUsuarioEliminarHTTP({ state, commit, dispatch }, body) {
      // try {

      return new Promise((res, rej) => {
        axios
          .post(`${BASE_URL}:${state.clave_empresa}/usuarios:eliminar`, body, {
            headers: { authorization: `Bearer ${state.token}` }
          })
          .then(response => {
            let newToken = response.headers.authorization;
            newToken = newToken.replace("Bearer ", "");
            commit("SET_TOKEN", newToken);
            return res(response.data);
          })
          .catch(err => {
            customCatchError(err, dispatch, rej);
          });
      });
    },
    recoverChangePassword({ state }, body) {
      // try {
      console.log(state);
      return new Promise((res, rej) => {
        axios
          .post(
            `${BASE_URL}:${body.clave_empresa}/usuarios:modificar_contrasena_recuperar`,
            body
          )
          .then(({ data }) => {
            res(data);
          })
          .catch(err => rej(err.response.data));
      });
    },
    reportsHTTP({ state }, body) {
      return new Promise((resp, rej) => {
        fetch(`${BASE_URL}:${state.clave_empresa}/reportes:excel`, {
          method: "POST",
          body: JSON.stringify(body),
          headers: {
            "Content-Type": "application/json",
            authorization: `Bearer ${state.token}`
          }
        })
          .then(res => {
            // console.log(res);

            if (res.status == 200) {
              return resp(res.blob());
            } else {
              const error = new Error("Ocurrio un error al generar el reporte");
              throw error;
              // return resp(error);
            }
            // return resp(res);
          })
          .catch(err => {
            // console.log(err);

            return rej(err);
          });
      });
    },
    reportsPDFHttp({ state }, body) {
      return new Promise((resp, rej) => {
        fetch(`${BASE_URL}:${state.clave_empresa}/reportes:html`, {
          method: "POST",
          body: JSON.stringify(body),
          headers: {
            "Content-Type": "application/json",
            authorization: `Bearer ${state.token}`
          }
        })
          .then(res => {
            // console.log(res);

            if (res.status == 200) {
              return resp(res.blob());
            } else {
              const error = new Error("Ocurrio un error al generar el reporte");
              throw error;
              // return resp(error);
            }
            // return resp(res);
          })
          .catch(err => {
            // console.log(err);

            return rej(err);
          });
      });
    },
    customIndicadoresHTTP({ state, commit, dispatch }, body) {
      return new Promise((res, rej) => {
        axios
          .post(
            `${BASE_URL}:${state.clave_empresa}/reportes:jsoniq`,
            body.body,
            {
              headers: { authorization: `Bearer ${state.token}` }
              // cancelToken: cancelToken.token
            }
          )
          .then(response => {
            let newToken = response.headers.authorization;
            newToken = newToken.replace("Bearer ", "");
            commit("SET_TOKEN", newToken);
            return res(response.data);
          })
          .catch(err => {
            // console.log(err);
            if (axios.isCancel) {
              return rej(err.message);
            }

            customCatchError(err, dispatch, rej);
          });
      });
    },
    customIndicadoresHTTPEf({ state, commit, dispatch }, body) {
      return new Promise((res, rej) => {
        axios
          .post(
            `${BASE_URL}:${state.clave_empresa}/reportes:jsoniq`,
            body.body,
            {
              headers: { authorization: `Bearer ${state.token}` }
              // cancelToken: cancelToken.token
            }
          )
          .then(response => {
            let newToken = response.headers.authorization;
            newToken = newToken.replace("Bearer ", "");
            Object.assign(response.data, { fecha: body.body.params.fecha });
            commit("SET_TOKEN", newToken);
            return res(response.data);
          })
          .catch(err => {
            // console.log(err);
            if (axios.isCancel) {
              return rej(err.message);
            }

            customCatchError(err, dispatch, rej);
          });
      });
    },
    getReportsHTTP({ state, commit, dispatch }, body) {
      // try {

      return new Promise((res, rej) => {
        axios
          .post(
            `${BASE_URL}:${state.clave_empresa}/reportes:consultar_excel`,
            body,
            { headers: { authorization: `Bearer ${state.token}` } }
          )
          .then(response => {
            let newToken = response.headers.authorization;
            newToken = newToken.replace("Bearer ", "");
            commit("SET_TOKEN", newToken);
            return res(response.data);
          })
          .catch(err => {
            customCatchError(err, dispatch, rej);
          });
      });
    },
    actMethod({ state, commit, dispatch }, { url, options, ...body }) {
      // try {

      return new Promise((res, rej) => {
        fetch(`${BASE_URL}:${state.clave_empresa}/${url}`, {
          ...options,
          method: "POST", // or 'PUT'
          body: JSON.stringify(body), // data can be `string` or {object}!
          headers: {
            "Content-Type": "application/json",
            authorization: `Bearer ${state.token}`
          }
        })
          .then(async res => {
            if (res.status >= 400) {
              throw {
                response: {
                  ...res,
                  status: res.status,
                  data: await res.json()
                }
              };
            }
            if (res.headers.get("authorization")) {
              let newToken = res.headers
                .get("authorization")
                .replace("Bearer ", "");
              commit("SET_TOKEN", newToken);
            }
            return res.json();
          })
          .then(response => {
            return res(response);
          })
          .catch(err => {
            customCatchError(err, dispatch, rej);
          });
      });
    },
    getReportsPdf({ state, commit, dispatch }, body) {
      // try {

      return new Promise((res, rej) => {
        axios
          .post(
            `${BASE_URL}:${state.clave_empresa}/reportes:consultar_html`,
            body,
            { headers: { authorization: `Bearer ${state.token}` } }
          )
          .then(response => {
            let newToken = response.headers.authorization;
            newToken = newToken.replace("Bearer ", "");
            commit("SET_TOKEN", newToken);
            return res(response.data);
          })
          .catch(err => {
            customCatchError(err, dispatch, rej);
          });
      });
    },
    updateStatus({ commit }, n) {
      // let ubicaciones = [{value: 1, label:"La Gotera"}]
      // ubicaciones.push(ubi)
      // state.count.push(ubi)
      commit("increment", n);
    },
    setAnalyticsFilter({ commit }, filter) {
      commit(SET_ANALYTICS_FILTER, filter);
    },
    setPreFilter({ commit }, filter) {
      commit(SET_PRE_FILTER, filter);
    },
    setGoBack({ commit }, filter) {
      commit(SET_GO_BACK, filter);
    }
  }
});

function customCatchError(err, dispatch, rej) {
  try {
    if (err.response.status == 401) {
      if (
        err.response.data.code ==
        "klayware.http.middleware.jwt_verify.handle.token_expirado"
      ) {
        dispatch("logout");
        console.log(err?.response);
      } else {
        return rej(
          err?.response?.data || {
            status: "fail",
            message: "Error de conexión verifique lo más tarde"
          }
        );
      }
    } else {
      return rej(
        err?.response?.data || {
          status: "fail",
          message: "Error de conexión verifique lo más tarde"
        }
      );
    }
  } catch (error) {
    return rej({
      status: "fail",
      message: "Error de conexión verifiquelo más tarde"
    });
  }
}

function hash(string) {
  //set variable hash as 0
  let hash = 0;
  // if the length of the string is 0, return 0
  if (string.length == 0) return hash;
  for (let i = 0; i < string.length; i++) {
    const ch = string.charCodeAt(i);
    hash = (hash << 5) - hash + ch;
    hash = hash & hash;
  }
  return hash;
}
